export const areBundleOptionsFromCart = (options) => options.length > 0 && "label" in options[0];
export const areBundleOptionsFromOrder = (options) => options.length > 0 && "product_name" in options[0];
//# sourceMappingURL=bundleOptions.js.map